import { createContext } from 'react';

/**
 * @deprecated
 */
var DeprecatedLayoutGroupContext = createContext(null);

export { DeprecatedLayoutGroupContext };
